export const getSexOptions = (t) => [
    { value: 'macho', label: t('admin.animal.sex_macho') },
    { value: 'hembra', label: t('admin.animal.sex_hembra') }
]